import React, { useEffect, useState, useRef } from 'react';

import { GenderInfoDrawer } from "../info_components/OrientationInfo"
import { SexualityInfoDrawer } from "../info_components/OrientationInfo"
import { MarriageInfoDrawer } from "../info_components/OrientationInfo"

import Button from '@mui/material/Button';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import ToggleButton from '@mui/material/ToggleButton';

import Fade from '@mui/material/Fade';


function GenderButton({ gender, onClick, backgroundColor, genderHint }) {
    return (
        <div className="genderButton">
            <div className={genderHint ? "genderButtonBorder" : "genderButtonNoBorder"}>
                <Button
                    onClick={(event) => {
                        onClick({
                            ...gender
                        });
                    }}
                    id={gender.gender}
                    className="button"
                    transition="background-color, transform,"
                    sx={{
                        minWidth: "130px",
                        height: "50px"
                        , color: "white"
                        , background: backgroundColor
                        , borderRadius: 28
                        , boxShadow: '0 2px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.02)'
                        , transition: "all .5s ease"
                    }}
                >
                    {gender.gender}
                </Button>
            </div>
        </div>
    );
};

function SexualityButton({ sexuality, onClick, backgroundColor, sexualityHint }) {
    return (
        <div className="genderButton">
            <div className={sexualityHint ? "genderButtonBorder" : "genderButtonNoBorder"}>

                <Button
                    onClick={(event) => {
                        onClick({
                            ...sexuality
                        });
                    }}
                    id={sexuality.sexuality}
                    className="button"
                    sx={{
                        minWidth: "130px",
                        height: "50px"
                        , color: "white"
                        , background: backgroundColor
                        , borderRadius: 28
                        , boxShadow: '0 2px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.02)'
                    }}
                >
                    {sexuality.sexuality}
                </Button>
            </div>
        </div>
    );
};

function MarriageButton({ marriage, onClick, backgroundColor, marriageHint }) {
    return (
        <div className="genderButton">
            <div className={marriageHint ? "genderButtonBorder" : "genderButtonNoBorder"}>

                <Button
                    onClick={(event) => {
                        onClick({
                            ...marriage
                        });
                    }}
                    id={marriage.marriage}
                    className="button"
                    sx={{
                        minWidth: "130px",
                        height: "50px"
                        , color: "white"
                        , background: backgroundColor
                        , borderRadius: 28
                        , boxShadow: '0 2px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.2),0 0 0 1px rgba(0,0,0,0.02)'
                    }}
                >
                    {marriage.marriage}
                </Button>
            </div>
        </div>
    );
};


export default function Gender({ activeGender, onGenderClick, activeSexuality, onSexualityClick, activeMarriage, onMarriageClick, activeTabBarStatus }) {
    const [genderHint, setGenderHint] = useState(false);
    const [sexualityHint, setSexualityHint] = useState(false);
    const [marriageHint, setMarriageHint] = useState(false);
    const [allActive, setAllActive] = useState(false);

    useEffect(() => {
        activeGender.every((e) => e.selected === false) ? setGenderHint(true) : setGenderHint(false)
        activeSexuality.every((e) => e.selected === false) ? setSexualityHint(true) : setSexualityHint(false)
        activeMarriage.every((e) => e.selected === false) ? setMarriageHint(true) : setMarriageHint(false)
    }, [activeGender, activeSexuality, activeMarriage]);

    const [genderInfo, setGenderInfo] = useState(false);
    const [sexualityInfo, setSexualityInfo] = useState(false);
    const [marriageInfo, setMarriageInfo] = useState(false);

    const [genderHelp, setGenderHelp] = useState(false);
    const [sexualityHelp, setSexualityHelp] = useState(false);
    const [marriageHelp, setMarriageHelp] = useState(false);


    return (
        <div className={activeTabBarStatus ? "wrapperScroll" : "wrapperScrollEstimates"}>
            <div className="componentContainer">

                <div className="genderContainer">
                    <Fade
                        // in={false ? true : false}
                        in={genderHelp ? true : false}
                        timeout={500}
                    >
                        <div className="helpContainer" onClick={() => { setGenderHelp(!genderHelp) }}>
                            <div className="helpBox">
                                <h2 className="helpText">Tips</h2>
                                <p className="helpText">- 🚻 Multiple gender identities can be selected.</p>
                                <p className="helpText">- 🤖 The percentage in the Orientation tab above updates as you adjust your selection, showing what share of the population it captures.</p>
                            </div>
                        </div>
                    </Fade>

                    <GenderInfoDrawer genderInfo={genderInfo} setGenderInfo={setGenderInfo} />
                    <SexualityInfoDrawer sexualityInfo={sexualityInfo} setSexualityInfo={setSexualityInfo} />
                    <MarriageInfoDrawer marriageInfo={marriageInfo} setMarriageInfo={setMarriageInfo} />

                    <div className="componentHeaderContainerSlim">
                        <div className="componentHeader">
                            <div className="descriptionContainer">
                                <p className="description">I'm interested in people who identify as</p>
                            </div>
                            <div className="info">
                                <ToggleButton
                                    value={1}
                                    selected={genderInfo}
                                    onChange={() => setGenderInfo((prevSelected) => !prevSelected)}
                                    sx={{ padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgb(45 185 255 / 17%)" } }}
                                >
                                    <InfoIcon />
                                </ToggleButton>
                                <ToggleButton
                                    value={1}
                                    selected={genderHelp}
                                    onChange={() => { setGenderHelp((prevSelected) => !prevSelected); setGenderInfo(false); }}
                                    sx={{ zIndex: 10, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                                >
                                    <HelpIcon />
                                </ToggleButton>
                            </div>
                        </div>
                        {/* <p className="note">(Min and max values represent bottom and top 5th percentiles)</p> */}
                    </div>
                    <div className="genderButtons">
                        {activeGender.map((gender) => (
                            <GenderButton key={gender.gender} gender={gender} onClick={onGenderClick} backgroundColor={gender.selected ? gender.color : "linear-gradient(.100turn, #2A2A2A, #A9A9A9)"} genderHint={genderHint}
                            />
                        ))}
                    </div>
                    <div>
                        <p className="sourceSlim">Source: U.S. Census Bureau, 2023 American Community Survey (NYC)</p>
                        {/* S0101 */}
                    </div>
                </div>


                <div className="genderContainer">
                    <Fade
                        // in={false ? true : false}
                        in={sexualityHelp ? true : false}
                        timeout={500}
                    >
                        <div className="helpContainer" onClick={() => { setSexualityHelp(!sexualityHelp) }}>
                            <div className="helpBox">
                                <h2 className="helpText">Tips</h2>
                                <p className="helpText">- 🤖 Multiple sexual orientations can be selected, which combine with selected gender identity(s) to calculate your dating pool. </p>
                                <p className="helpText">- 🚻 For example, choosing [Women] and [Men] with [Straight] and [Gay or Lesbian] includes: </p>
                                <ul style={{ margin: 0 }}>
                                    <li className="helpText">Straight women and men</li>
                                    <li className="helpText">Lesbian women and gay men</li>
                                </ul>
                                <p className="helpText">- ❌ Unfortunately, higher specificity, like only straight men and lesbian women cannot be achieved with this gender and sexual orientation combination.</p>
                            </div>
                        </div>
                    </Fade>

                    <div className="componentHeaderContainerSlim">
                        <div className="componentHeader">
                            <div className="descriptionContainer">
                                <p className="description">...whose sexual orientation is</p>
                            </div>
                            <div className="info">

                                <ToggleButton
                                    value={1}
                                    selected={sexualityInfo}
                                    onChange={() => setSexualityInfo((prevSelected) => !prevSelected)}
                                    sx={{ padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgb(45 185 255 / 17%)" } }}
                                >
                                    <InfoIcon />
                                </ToggleButton>
                                <ToggleButton
                                    value={1}
                                    selected={sexualityHelp}
                                    onChange={() => { setSexualityHelp((prevSelected) => !prevSelected); setSexualityInfo(false) }}
                                    sx={{ zIndex: 11, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                                >
                                    <HelpIcon />
                                </ToggleButton>
                            </div>
                        </div>
                        {/* <p className="note">(Min and max values represent bottom and top 5th percentiles)</p> */}
                    </div>
                    <div className="genderButtons">
                        {activeSexuality.map((sexuality) => (
                            <SexualityButton key={sexuality.sexuality} sexuality={sexuality} onClick={onSexualityClick} backgroundColor={sexuality.selected ? sexuality.color : "linear-gradient(.100turn, #2A2A2A, #A9A9A9)"}
                                sexualityHint={sexualityHint} />
                        ))}
                    </div>
                    <div>
                        <p className="sourceSlim">Source: U.S. Census Bureau, 2021 Household Pulse Survey</p>
                    </div>
                </div>


                <div className="genderContainer">
                    <Fade
                        // in={false ? true : false}
                        in={marriageHelp ? true : false}
                        timeout={500}
                    >
                        <div className="helpContainer" onClick={() => { setMarriageHelp(!marriageHelp) }}>
                            <div className="helpBox">
                                <h2 className="helpText">Tips</h2>
                                <p className="helpText">- 🤖 Marital status is correlated with gender and age when calculating dating pool. For example, among 20–34 year-olds, about 20% more women are married than men.</p>
                                <p className="helpText">- 💍 Be mindful that marital status does not equate to relationship status—for example, someone may have never been married but still be in a relationship.</p>
                            </div>
                        </div>
                    </Fade>
                    <div className="componentHeaderContainerSlim">
                        <div className="componentHeader">
                            <div className="descriptionContainer">
                                <p className="description">...whose marital status is</p>
                            </div>
                            <div className="info">
                                {/* <Tooltip
                                    title={<>
                                        <p className="correlatedText">Gender & marital status data </p>
                                        <p className="correlatedText">are correlated</p>
                                    </>}
                                    placement="top"
                                    arrow
                                    enterTouchDelay={0}
                                    enterDelay={200}
                                    leaveTouchDelay={4000}
                                    slots={{
                                        transition: Zoom,
                                    }}
                                    slotProps={{
                                        popper: {
                                            modifiers: [
                                                {
                                                    name: 'offset',
                                                    options: {
                                                        offset: [0, -10],
                                                    },
                                                },
                                            ],
                                        },
                                        tooltip: { sx: { fontSize: '13px' } }
                                    }}
                                >
                                    <WcIcon fontSize="small" className="correlatedIcon" />
                                </Tooltip> */}
                                <ToggleButton
                                    value={1}
                                    selected={marriageInfo}
                                    onChange={() => setMarriageInfo((prevSelected) => !prevSelected)}
                                    sx={{ padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgb(45 185 255 / 17%)" } }}
                                >
                                    <InfoIcon />
                                </ToggleButton>
                                <ToggleButton
                                    value={1}
                                    selected={marriageHelp}
                                    onChange={() => { setMarriageHelp((prevSelected) => !prevSelected); setMarriageInfo(false); }}
                                    sx={{ zIndex: 11, padding: '0px', border: '0px', height: "26px", width: "26px", "&.MuiButtonBase-root.MuiToggleButton-root.Mui-selected": { backgroundColor: "rgba(87, 156, 202, 1)" } }}
                                >
                                    <HelpIcon />
                                </ToggleButton>
                            </div>
                        </div>
                        {/* <p className="note">(Min and max values represent bottom and top 5th percentiles)</p> */}
                    </div>
                    <div className="genderButtons">
                        {activeMarriage.map((marriage) => (
                            <MarriageButton key={marriage.marriage} marriage={marriage} onClick={onMarriageClick} backgroundColor={marriage.selected ? marriage.color : "linear-gradient(.100turn, #2A2A2A, #A9A9A9)"} marriageHint={marriageHint}
                            />
                        ))}
                    </div>
                    <div>
                        <p className="sourceSlim">Source: U.S. Census Bureau, 2019-2023 American Community Survey (NYC) </p>
                        {/* S1201 */}
                    </div>
                </div>
            </div>
        </div>
    );
}